// src/App.js
import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Movies from "./pages/Movies";
import MovieDetail from "./pages/MovieDetail";
import SeriesDetail from "./pages/SeriesDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";        // <-- Ajusta a uppercase
import Upload from "./pages/Upload";
import Creators from "./pages/Creators";
import SubmissionsAdmin from "./pages/SubmissionsAdmin";
import UsersAdmin from "./pages/UsersAdmin";
import VideosAdmin from "./pages/VideosAdmin";
import { getCurrentUser, logoutUser } from "./utils/auth";

function App() {
  const [user, setUser] = useState(getCurrentUser());
  const navigate = useNavigate();

  useEffect(() => {
    // Puedes sincronizar user con localStorage u otros efectos aquí
  }, [user]);

  const handleLogout = () => {
    logoutUser();
    setUser(null);
    navigate("/login");
  };

  return (
    <div className="app-container">
      <Navbar user={user} onLogout={handleLogout} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/movies/:id" element={<MovieDetail />} />
          <Route path="/series/:id" element={<SeriesDetail user={user} />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/register" element={<Register setUser={setUser} />} />  {/* Import correcto */}
          <Route path="/upload" element={<Upload />} />
          <Route path="/creators" element={<Creators />} />
          <Route path="/admin/submissions" element={<SubmissionsAdmin />} />
          <Route path="/admin/users" element={<UsersAdmin />} />
          <Route path="/admin/videos" element={<VideosAdmin />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
